// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 805) return "static/chunks/805-519afdd94b43f28a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"127":"627c860e4e43b2da","331":"4af10214a66b6538","357":"2cc16a7239d348b6","400":"e3e49d67c1920d77","447":"2f46bb3fc5554525","580":"f450847e78c7ad7f","631":"c5a7475a2dbdae4d","782":"6c759049a2ac078d","961":"8b7bc5be75cec3c2"}[chunkId] + ".js";
};